import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dash-grid" }

import { ref, computed } from 'vue';
import LocationCard from "@/components/data/LocationCard.vue";
import LocationModal from "@/components/data/LocationModal.vue";
import EnvironmentConfigModal from "@/components/data/EnvironmentConfigModal.vue"; // 👈 New Import
import StatCard from "@/components/ui/StatCard.vue";
import THChartCard from "@/components/data/THChartCard.vue";
import SensorStatusCard from "@/components/data/SensorStatusCard.vue";

const TEMP_PRECISION = 1;
const HUM_PRECISION = 0;

export default /*@__PURE__*/_defineComponent({
  __name: 'EnvironmentSection',
  props: {
    deviceId: {},
    deviceName: {},
    location: {},
    currentTempC: {},
    outsideHum: {},
    lastUpdateAgo: {},
    chartRange: {},
    seriesT: {},
    seriesH: {},
    showMap: { type: Boolean },
    tempMin: {},
    tempMax: {},
    humMin: {},
    humMax: {},
    loading: { type: Boolean }
  },
  emits: ['refresh', 'center', 'copyCoords', 'update:range'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const showCoordModal = ref(false);
const showConfigModal = ref(false);

const shouldShowMap = computed(() => props.showMap !== false); // Default true

/* precisioni helpers */
function floorToDecimals(n: number, d = 1) {
  const k = Math.pow(10, d);
  return Math.floor(n * k) / k;
}
const formatTempC = (n: number) => `${floorToDecimals(n, TEMP_PRECISION).toFixed(TEMP_PRECISION)}°C`;
const formatHum = (n: number) => `${Math.floor(n).toFixed(HUM_PRECISION)}%`;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (shouldShowMap.value)
      ? (_openBlock(), _createBlock(LocationCard, {
          key: 0,
          class: "span-1",
          isEnabled: true,
          deviceName: __props.deviceName,
          location: __props.location,
          onRefresh: _cache[0] || (_cache[0] = ($event: any) => (emit('refresh'))),
          onCenter: _cache[1] || (_cache[1] = ($event: any) => (emit('center'))),
          onOpenModal: _cache[2] || (_cache[2] = ($event: any) => (showCoordModal.value = true))
        }, null, 8, ["deviceName", "location"]))
      : _createCommentVNode("", true),
    (shouldShowMap.value)
      ? (_openBlock(), _createBlock(SensorStatusCard, {
          key: 1,
          class: "span-3",
          deviceId: __props.deviceId
        }, null, 8, ["deviceId"]))
      : _createCommentVNode("", true),
    (showCoordModal.value)
      ? (_openBlock(), _createBlock(LocationModal, {
          key: 2,
          deviceName: __props.deviceName,
          deviceId: __props.deviceId,
          location: __props.location,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (showCoordModal.value = false)),
          onCopy: _cache[4] || (_cache[4] = ($event: any) => (emit('copyCoords'))),
          onSaved: _cache[5] || (_cache[5] = ($event: any) => (emit('refresh')))
        }, null, 8, ["deviceName", "deviceId", "location"]))
      : _createCommentVNode("", true),
    (showConfigModal.value)
      ? (_openBlock(), _createBlock(EnvironmentConfigModal, {
          key: 3,
          "device-id": __props.deviceId,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (showConfigModal.value = false)),
          onSaved: _cache[7] || (_cache[7] = ($event: any) => (emit('refresh')))
        }, null, 8, ["device-id"]))
      : _createCommentVNode("", true),
    _createVNode(THChartCard, {
      class: "card span-2",
      title: "Current Temperature",
      type: "temp",
      "is-enabled": true,
      "series-t": __props.seriesT,
      "series-h": [],
      "current-temp": __props.currentTempC,
      "last-update-ago": __props.lastUpdateAgo,
      "current-range": __props.chartRange,
      "temp-min": __props.tempMin,
      "temp-max": __props.tempMax,
      loading: __props.loading,
      "onUpdate:range": _cache[8] || (_cache[8] = ($event: any) => (emit('update:range', $event))),
      onRefresh: _cache[9] || (_cache[9] = ($event: any) => (emit('refresh'))),
      onConfig: _cache[10] || (_cache[10] = ($event: any) => (showConfigModal.value = true))
    }, null, 8, ["series-t", "current-temp", "last-update-ago", "current-range", "temp-min", "temp-max", "loading"]),
    _createVNode(THChartCard, {
      class: "card span-2",
      title: "Current Humidity",
      type: "hum",
      "is-enabled": true,
      "series-t": [],
      "series-h": __props.seriesH,
      "current-hum": __props.outsideHum,
      "last-update-ago": __props.lastUpdateAgo,
      "current-range": __props.chartRange,
      "hum-min": __props.humMin,
      "hum-max": __props.humMax,
      loading: __props.loading,
      "onUpdate:range": _cache[11] || (_cache[11] = ($event: any) => (emit('update:range', $event))),
      onRefresh: _cache[12] || (_cache[12] = ($event: any) => (emit('refresh'))),
      onConfig: _cache[13] || (_cache[13] = ($event: any) => (showConfigModal.value = true))
    }, null, 8, ["series-h", "current-hum", "last-update-ago", "current-range", "hum-min", "hum-max", "loading"])
  ]))
}
}

})